import * as React from 'react'
import Box from '@mui/material/Box'
import Button from '@mui/material/Button'
import { useLoaderData, useNavigate } from 'react-router-dom'
import PageAppBar from 'components/PageAppBar'
import { ProfileModel } from 'types'
import ProfileDataGrid from 'components/ProfileDataGrid'

export default function ProfilesPage() {
  const profiles = useLoaderData() as ProfileModel[]
  const navigate = useNavigate()

  return (
    <PageAppBar pageName="Profiles">
      <Box
        sx={{
          padding: '1rem',
          height: 'calc(100vh - 64px)',
          display: 'flex',
          flexDirection: 'column',
        }}
      >
        <Box
          sx={{
            display: 'flex',
            justifyContent: 'space-between',
            alignItems: 'center',
            mb: 1,
          }}
        >
          <Button variant="contained" onClick={() => navigate('/profile')}>
            Créer un profil
          </Button>
        </Box>

        <Box sx={{ flexGrow: 1, width: '100%' }}>
          <ProfileDataGrid profiles={profiles} />
        </Box>
      </Box>
    </PageAppBar>
  )
}
